import React from 'react'
import './QuestionStep/style/Q2.css'
export default function FourOptions({ option1, option2, option3, option4, onOption1Press, onOption2Press, onOption3Press, onOption4Press }) {

    return (
        <>
            <button className="allOptions firstOption" onClick={onOption1Press} type="button">{option1}</button>
            <button className="allOptions secondOption" onClick={onOption2Press} type="button">{option2}</button>
            <button className="allOptions thirdOption" onClick={onOption3Press} type="button">{option3}</button>
            <button className="allOptions fourthOption" onClick={onOption4Press} type="button">{option4}</button>
        </>
    )
}
